/**
 * Aba "Configurações" da Gestão de Solicitações — por unidade:
 *   - Classificação: catálogos (demandas, NCs, processos, causas-raiz)
 *   - Prazos por rota: dias úteis prometidos e folga do setor
 *   - Regras: exigência de classificação, retirada e réguas do backlog
 *
 * Quem gere solicitações LÊ; só `solicitacao:configurar` altera.
 */
import React, { useState } from "react";

import { useAuth } from "../../../../context/AuthContext";
import { NeutralBanner, ToggleBtn, ViewToggle } from "../styles";
import CatalogosSecao from "./CatalogosSecao";
import PrazosSecao from "./PrazosSecao";
import RegrasSecao from "./RegrasSecao";

const SECOES = [
  { id: "classificacao", label: "Classificação" },
  { id: "prazos", label: "Prazos por rota" },
  { id: "regras", label: "Regras" },
];

export default function ConfiguracoesTab() {
  const { hasPermission } = useAuth();
  const podeEditar = hasPermission("solicitacao:configurar");
  const [secao, setSecao] = useState("classificacao");

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14, paddingBottom: 32 }}>
      <ViewToggle style={{ alignSelf: "flex-start" }}>
        {SECOES.map((s) => (
          <ToggleBtn key={s.id} type="button" $active={secao === s.id} onClick={() => setSecao(s.id)}>
            {s.label}
          </ToggleBtn>
        ))}
      </ViewToggle>
      {!podeEditar && (
        <NeutralBanner>
          Você pode consultar. Para alterar, peça a permissão "Configurar solicitações".
        </NeutralBanner>
      )}
      {secao === "classificacao" && <CatalogosSecao podeEditar={podeEditar} />}
      {secao === "prazos" && <PrazosSecao podeEditar={podeEditar} />}
      {secao === "regras" && <RegrasSecao podeEditar={podeEditar} />}
    </div>
  );
}
